// Copyright © Perilous Games, Ltd., 2025. All Rights Reserved. Coded by Alexander Fields https://www.alexanderfields.me on 2025-07-02 17:26:24

/**
 * @fileoverview Application entry point for Perilous Games website
 * @module index
 * @description
 *   Bootstraps the React application by mounting the root App component
 *   to the DOM. Uses React 18's createRoot API with StrictMode for
 *   development checks. Also unregisters any existing service workers
 *   to prevent stale cache issues, and initializes web vitals reporting.
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Unregister any existing service workers to prevent stale cache issues
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister()
    }
  })
}

reportWebVitals()
